import { render, staticRenderFns } from "./change-success.vue?vue&type=template&id=54bb6e2c&scoped=true&"
import script from "./change-success.vue?vue&type=script&lang=ts&"
export * from "./change-success.vue?vue&type=script&lang=ts&"
import style0 from "./change-success.vue?vue&type=style&index=0&id=54bb6e2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bb6e2c",
  null
  
)

export default component.exports